




















import {Component, Prop} from "vue-property-decorator";

import {InputType} from "@/enums/InputType";

import FormBase from "@/components/Form/InputComponents/FormBase.vue";
import {Option} from "@/util/Option";

@Component({})
  export default class SearchFormInput extends FormBase {
    @Prop({required:true}) type!:InputType;
    @Prop() placeholder?:string;
    @Prop({required:true}) options!: Option[];
    optionsVisible = false

  get showOptions(){
   return this.optionsVisible
  }

  optionSelected(option: Option){
    this.$emit('optionSelected', option.value)
    this.optionsVisible = false;
    this.value = option.text
  }

    get filteredOptions(){
      return this.options.filter(option => {
        if (typeof this.value === 'string') {
          return option.text.toLowerCase().includes(this.value.toLowerCase())
        }
      });
    }
  }

